/**
 * Classe responsável pela funcionalidade do menu
 * para o grid de rota.
 * @author: adalto.junior
 * Date: 08/10/13
 * Time: 22:16
 */
import React from 'react';
import { push } from 'connected-react-router';
import moment from 'moment';
import RouteDataModal from 'react/containers/modals/RouteOtherData';
import { renderComponent } from 'react/utils/renderUtils';
import { navigateToRouteDetails } from 'react/utils/routeDetails';
import { actionCreators as actionsModals } from 'react/api/actions/modals';
import {
  validIfServerVersionIsLowerThan,
  validIfBuildNumberIsLowerThan
} from 'react/utils/utils';

Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.Route = Greenmile.RouteSummary.Route || {};

Greenmile.RouteSummary.Route.Menu = (function () {
  function Menu() {
    Greenmile.Grid.Menu.apply(this, arguments);

    const actionGridMenu = {
      ROUTE_DETAIL: 'btn_route_detail_menu',
      TRANSFER_STOPS: 'btn_transfer_stop_menu',
      START_ROUTE: 'btn_start_route_menu',
      DEPART_FROM_ORIGIN: 'btn_depart_origin_menu',
      ARRIVE_DESTINATION: 'btn_arrive_destination_menu',
      COMPLETE_ROUTE: 'btn_complete_route_menu',
      CLONE_ROUTE: 'btn_clone_route_menu',
      OTHER_DATA: 'route_summary_other_data_btn'
    };

    this.goToRouteMonitor = ({ organizationId, key, date }) => {
      const startDate = moment(date).subtract(1, 'months').format('YYYY-MM-DD');
      const endDate = moment(date).add(1, 'months').format('YYYY-MM-DD');
      const path = `/RouteMonitor?startDate=${startDate}&endDate=${endDate}&organizationId=${organizationId}&queryParameter=${key}`;

      window.GreenmileReduxStore.dispatch(push(path));
    };

    // Helper functions as arrow functions
    const createRouteDetailItem = (route, routeId, gridMenu) => ({
      id: 1,
      description: Monet.I18n.getResourcesByKey(
        'Routesummary.Menu.Viewroutedetails'
      ),
      icon: 'viewRouteDetails',
      customClassname: 'RouteDetailsItem',
      action: () => {
        const hash = `#/maps/route/${routeId}/details`;
        gridMenu.removeAllMenus();
        if (hash === window.location.hash) {
          const routeDetail = new App.Routers.RouteDetails();
          routeDetail.show(routeId);
        } else {
          navigateToRouteDetails(route.toJSON());
        }
      }
    });

    const createListStopsItem = (route, gridMenu) => ({
      id: 2,
      description: Monet.I18n.getResourcesByKey('RouteMonitor.filter.stopList'),
      icon: 'listStops',
      customClassname: 'StopListItem',
      action: () => {
        gridMenu.removeAllMenus();
        App.Forms.RouteSummaryStops.route = route;
        Monet.Grid.Utils.clearPagination('RouteSummaryStops');
        const hash = '#/RouteSummary/Stops';
        if (hash === window.location.hash) {
          App.Views.RouteSummary.showGridStop();
        } else {
          window.location = hash;
        }
      }
    });

    const createTransferStopsItem = (routeId, gridMenu) => ({
      id: 3,
      description: Monet.I18n.getResourcesByKey(
        'RouteMonitor.filter.transferStop'
      ),
      icon: 'transferStops',
      customClassname: 'TransferStopsItem',
      action: () => {
        const transferStops = new Greenmile.Route.TransferStops.Popup();
        gridMenu.removeAllMenus();
        transferStops.setFromRouteId(routeId);
        transferStops.showTransferStops();
      }
    });

    const createStartRouteItem = (route, gridMenu) => ({
      id: 4,
      description: Monet.I18n.getResourcesByKey(
        'Greenmile.Route.Start.btnSave'
      ),
      icon: 'startRouteBtn',
      customClassname: 'StartRouteItem',
      action: () => {
        const startRoute = new Greenmile.Route.Start();
        gridMenu.removeAllMenus();
        startRoute.setRoute(route);
        startRoute.show();
      }
    });

    const createDepartOriginItem = (route, gridMenu) => ({
      id: 5,
      description: Monet.I18n.getResourcesByKey(
        'Greenmile.Route.DepartOrigin.btnSave'
      ),
      icon: 'departOriginBtn',
      customClassname: 'DepartOriginItem',
      action: () => {
        const departOrigin = new Greenmile.Route.DepartOrigin();
        gridMenu.removeAllMenus();
        departOrigin.setRoute(route);
        departOrigin.show();
      }
    });

    const createArriveDestinationItem = (route, gridMenu) => ({
      id: 6,
      description: Monet.I18n.getResourcesByKey(
        'Greenmile.Route.ArriveDestination.btnSave'
      ),
      icon: 'arriveDestinationBtn',
      customClassname: 'ArriveDestinationItem',
      action: () => {
        const arriveDestination = new Greenmile.Route.ArriveDestination();
        gridMenu.removeAllMenus();
        arriveDestination.setRoute(route);
        arriveDestination.show();
      }
    });

    const createCompleteRouteItem = (route, gridMenu) => ({
      id: 7,
      description: Monet.I18n.getResourcesByKey(
        'Greenmile.Route.Complete.btnSave'
      ),
      icon: 'completeRouteBtn',
      customClassname: 'CompleteRouteItem',
      action: () => {
        const completeRoute = new Greenmile.Route.Complete();
        gridMenu.removeAllMenus();
        completeRoute.setRoute(route);
        completeRoute.show();
      }
    });

    const createCloneRouteItem = (route, gridMenu) => ({
      id: 8,
      description: Monet.I18n.getResourcesByKey(
        'Greenmile.Route.Clone.btnSave'
      ),
      icon: 'cloneRouteBtn',
      customClassname: 'CloneRouteItem',
      action: () => {
        const clonetRoute = new Greenmile.Route.Clone('RouteSummary');
        gridMenu.removeAllMenus();
        clonetRoute.setRoute(route);
        clonetRoute.show();
      }
    });

    const handleRouteDataModalSuccess = (route) => () => {
      renderComponent(
        <RouteDataModal open="true" route={route} i18n={Monet.I18n} />,
        document.getElementById('templates_container')
      );
    };

    const routeFilterCriteria = {
      filters: [
        'additionalMaterials.transport.key',
        'additionalMaterials.quantity',
        'additionalMaterials.sku.key',
        'additionalMaterials.sku.description',
        'additionalMaterials.sku.organization.key',
        'holderMaterials.id',
        'holderMaterials.transport.id',
        'holderMaterials.transport.key',
        'holderMaterials.sku.key',
        'holderMaterials.sku.description',
        'holderMaterials.sku.organization.key',
        'holderMaterials.size1Quantity',
        'holderMaterials.size2Quantity',
        'holderMaterials.size3Quantity',
        'holderMaterials.size1Alias',
        'holderMaterials.size2Alias',
        'holderMaterials.size3Alias',
        'additionalMaterials.quantity',
        'additionalMaterials.sizeAlias',
        'helperAssignments.helper.id',
        'helperAssignments.helper.key',
        'helperAssignments.helper.name',
        'helperAssignments.helper.login',
        'helperAssignments.helper.phone1',
        'helperAssignments.helper.phone2',
        'driverPendingBalances.description',
        'driverPendingBalances.amount',
        'driverPendingBalances.quantity',
        'locationPendingPayments.location.id',
        'locationPendingPayments.location.key',
        'locationPendingPayments.location.description',
        'locationPendingPayments.location.addressLine1',
        'locationPendingPayments.location.addressLine2',
        'locationPendingPayments.location.organization.key',
        'locationPendingPayments.documentKey',
        'locationPendingPayments.saleDate',
        'locationPendingPayments.dueDate',
        'locationPendingPayments.invoice',
        'locationPendingPayments.amount',
        'locationPendingPayments.amountPayed',
        'locationPendingPayments.remark',
        'extraLineItems.sku.description',
        'extraLineItems.plannedSize1',
        'extraLineItems.plannedSize2',
        'extraLineItems.plannedSize3',
        'extraLineItems.availableSize1',
        'extraLineItems.availableSize2',
        'extraLineItems.availableSize3'
      ]
    };

    const createRouteDataItem = (route) => ({
      id: 9,
      description: Monet.I18n.getResourcesByKey('Greenmile.Route.Other.Data'),
      icon: 'otherDataBtn',
      customClassname: 'OtherDataItem',
      action: () => {
        route.filterWithRestrictions({
          criteria: JSON.stringify(routeFilterCriteria),
          success: handleRouteDataModalSuccess(route)
        });
      }
    });

    const createViewOnRouteMonitorItem = (route) => ({
      id: 10,
      description: Monet.I18n.getResourcesByKey(
        'Routesummary.Menu.ViewOnRouteMonitor'
      ),
      icon: 'goToMark',
      customClassname: 'ViewOnRouteMonitorItem',
      action: () => {
        const { organization, key, date } = route.attributes;
        const organizationId = organization.id;
        this.goToRouteMonitor({ organizationId, key, date });
      }
    });

    const createManageAssignmentsItem = (routeId) => ({
      id: 11,
      description: Monet.I18n.getResourcesByKey(
        'Routesummary.Menu.ManageAssignments'
      ),
      icon: 'routeAssignment',
      customClassname: 'ManageAssignmentsItem',
      action: () => {
        window.GreenmileReduxStore.dispatch(
          actionsModals.openModal({
            modalKey: 'routeAssignments',
            title: Monet.I18n.getResourcesByKey(
              'routePanel.routeAssignments.title'
            ),
            data: {
              routeId,
              subtitle: Monet.I18n.getResourcesByKey(
                'modal.routeAssignments.subtitle'
              )
            }
          })
        );
      }
    });

    const renderMenuItems = (route) => {
      const items = [];
      const enabledMenus = this.getEnabledMenu();
      const routeId = route.get('id');
      const routeStatus = route.get('status');
      const gridMenu = this.gridMenu;

      if (enabledMenus.isEnabled(actionGridMenu.ROUTE_DETAIL)) {
        items.push(createRouteDetailItem(route, routeId, gridMenu));
      }

      if (routeStatus !== 'COMPLETED') {
        items.push(createViewOnRouteMonitorItem(route));
      }

      items.push(createListStopsItem(route, gridMenu));

      if (enabledMenus.isEnabled(actionGridMenu.CLONE_ROUTE)) {
        items.push(createCloneRouteItem(route, gridMenu));
      }

      if (
        routeStatus === 'NOT_STARTED' &&
        enabledMenus.isEnabled(actionGridMenu.START_ROUTE)
      ) {
        items.push(createStartRouteItem(route, gridMenu));
      } else if (
        routeStatus === 'STARTED' &&
        enabledMenus.isEnabled(actionGridMenu.DEPART_FROM_ORIGIN)
      ) {
        items.push(createDepartOriginItem(route, gridMenu));
      } else if (
        routeStatus === 'DEPARTED_ORIGIN' &&
        enabledMenus.isEnabled(actionGridMenu.ARRIVE_DESTINATION)
      ) {
        items.push(createArriveDestinationItem(route, gridMenu));
      } else if (
        routeStatus === 'ARRIVED_ORIGIN' &&
        enabledMenus.isEnabled(actionGridMenu.COMPLETE_ROUTE)
      ) {
        items.push(createCompleteRouteItem(route, gridMenu));
      }

      if (
        routeStatus !== 'COMPLETED' &&
        enabledMenus.isEnabled(actionGridMenu.TRANSFER_STOPS)
      ) {
        items.push(createTransferStopsItem(routeId, gridMenu));
        items.push(createManageAssignmentsItem(routeId));
      }

      if (
        (validIfServerVersionIsLowerThan(6.61) &&
          validIfBuildNumberIsLowerThan(1182283)) ||
        enabledMenus.isEnabled(actionGridMenu.OTHER_DATA)
      ) {
        items.push(createRouteDataItem(route));
      }

      return items;
    };

    this.getItemsToMenu = function (modelRoute) {
      const route = new App.Models.Route(modelRoute.get('route'));
      if (!route.attributes) return items;

      return renderMenuItems(route);
    };
  }

  return Menu;
})();
